<template>
  <div class="invoice-header">
    <div class="grid-row">
      <div class="column">
        <div class="invoice-detail-list list">
          <div class="invoice-detail-list-header list-header">
            <ul>
              <li>{{$_('delivery_form_number')}}</li>
              <li>{{$_('date')}}</li>
              <li>{{$_('carrier')}}</li>
              <li>{{$_('number_of_packages')}}</li>
              <li>{{$_('gross_weight_in_kg')}}</li>
              <li>{{$_('status')}}</li>
              <li>{{$_('main_tracking_number')}}</li>
              <li>{{$_('ttc_amount')}}</li>
              <li>{{$_('download')}}</li>
            </ul>
          </div>
          <div class="invoice-list-body list-body">
            <div v-for="(item, index) in items" :key="index">
              <InvoiceDetailsLine :dataline="item" :index="index" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import invoiceService from "@/modules/facture/services/invoiceService";

import InvoiceDetailsLine from "@/modules/facture/components/InvoiceDetailsLine";

export default {
  name: "InvoiceDetailsList",
  components: {
    InvoiceDetailsLine
  },
  data() {
    return {
      items: []
    };
  },
  created() {
    let tnfac = this.$route.params.invoice_id;

    invoiceService
      .getInvoiceDetailsList(tnfac)
      .then(res => {
        if (res.data.DS_O !== undefined) {
          res.data.DS_O.OUT.map(obj => {
            this.items.push(obj);
          });
        }
      })
      .catch(err => {
        console.error(err);
      });
  }
};
</script>

<style scoped>
.invoice-detail-list {
  padding: 30px 0px;
}
.invoice-detail-list-header ul {
  display: flex;
}
.invoice-detail-list-header ul li {
  list-style-type: none;
  display: flex;
  width: calc(100% / 9);
  text-align: center;
  padding: 0px 20px;
  justify-content: center;
}
.invoice-detail-list-header {
  padding: 15px 0px;
}
</style>